import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-table__cell" };
const _hoisted_2 = {
    key: 0,
    class: "data-table__check"
};
const _hoisted_3 = ["checked"];
const _hoisted_4 = { class: "data-table__value" };
const _hoisted_5 = { class: "data-table__value-text" };
const _hoisted_6 = { class: "data-table__value-text" };
import { computed, inject, onBeforeUnmount, onMounted, ref } from 'vue';
import { DATA_TABLE_CONTEXT } from "./context";
import { isSelected } from "./itemSelections";
import DataTableSlotOutlet from "./DataTableSlotOutlet";
/**
 * A row of the list (left, fixed) part of the data table: the item's
 * title and topic (or the consumer's `list-item` slot) and the bulk
 * selection checkbox.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableListRow',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const ctx = inject(DATA_TABLE_CONTEXT);
        const el = ref(null);
        const hover = computed(() => ctx.hoveredItemId.value === props.item.id);
        const active = computed(() => ctx.activeItemId.value === props.item.id);
        const selected = computed(() => isSelected(ctx.selection.value, props.item.id));
        const rowClass = computed(() => ({
            'data-table__row--hover': hover.value,
            'data-table__row--active': active.value,
            ['data-table__row--status-' + props.item.status]: true,
        }));
        // the list row is what gets scrolled into view when an item is activated
        onMounted(() => el.value && ctx.rowElements.set(props.item.id, el.value));
        onBeforeUnmount(() => ctx.rowElements.delete(props.item.id));
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "el",
                ref: el,
                class: _normalizeClass(["data-table__row", rowClass.value]),
                onMouseover: _cache[2] || (_cache[2] = ($event) => (_unref(ctx).setHovered(__props.item.id)))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_unref(ctx).capabilities.value.bulkOperations)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("input", {
                                checked: selected.value,
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(ctx).toggleSelection(__props.item))),
                                type: "checkbox",
                                name: "select"
                            }, null, 8, _hoisted_3)
                        ]))
                        : _createCommentVNode("", true),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(ctx).activate(__props.item))),
                        class: "data-table__list-item"
                    }, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(DataTableSlotOutlet), {
                                slots: _unref(ctx).slots,
                                name: "list-item",
                                scope: { item: __props.item }
                            }, {
                                default: _withCtx(() => [
                                    (_unref(ctx).itemRoute.value)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: _unref(ctx).createItemRoute(__props.item)
                                        }, {
                                            default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(__props.item.topic), 513), [
                                                    [_vShow, __props.item.topic]
                                                ]),
                                                _cache[3] || (_cache[3] = _createTextVNode()),
                                                _createElementVNode("span", _hoisted_5, _toDisplayString(__props.item.title), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["to"]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(__props.item.topic), 513), [
                                                [_vShow, __props.item.topic]
                                            ]),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.item.title), 1)
                                        ], 64))
                                ]),
                                _: 1
                            }, 8, ["slots", "scope"])
                        ])
                    ])
                ])
            ], 34));
        };
    }
});
